var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({staticClass:"timezone-input",attrs:{"items":_vm.items,"label":_vm.label,"dense":"","item-text":"label","item-value":"timezone","outlined":""},on:{"change":function($event){return _vm.$emit('change')}}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }